<template>
    <main class="c-page__main c-page__main--ugc c-post__page" role="main">
        <div class="o-wrapper">
            <div class="c-post__back--wrapper">
                <a class="c-post__back" :href="'/' + post.community_url" ref="community-back">
                    <img src="/img/ui/back-arrow.svg" alt="Back Arrow" width="9" height="14">
                    <p>Back</p>
                </a>
            </div>
            <article id="post-view" class="o-grid o-grid--center">
                <header class="c-post-click o-grid__item c-post__top u-width-8/12 u-p-t3 u-width-10/12@l u-width-full@m u-m-t2@m u-m-t0@s">
                    <div ref="articleHead" class="c-article__head">
                        <div ref="communityLogo" class="c-article__img">
                            <a :href="'/' + post.community_url">
                                <img :src="$simpleStore.cloudinaryUrl(106, 106, 'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)" :alt="post.community_name">
                            </a>
                        </div>
                        <div ref="articleTitle" :class="['c-article__title', 'u-flex@m', 'u-flex-direction-column@m', sticky ? 'scroll' : '']">
                            <div class="c-article__posted u-order-2@m">
                                <a :href="'/' + post.community_url" class="u-hidden u-block@s">
                                    <img :src="$simpleStore.cloudinaryUrl(54, 54, 'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)" :alt="post.community_name">
                                </a>
                                <div class="c-article__posted-by">
                                    <template v-if="post.network_id === $simpleStore.Networks.DY">
                                        <div>
                                            <figure class="ugc">
                                                <a :href="'/u/' + post.username">
                                                    <img :src="post.user_avatar" class="ugc__img"
                                                         :alt="'Article Posted by ' + post.first_name + ' ' + post.surname">
                                                </a>
                                            </figure>
                                            <!-- TODO Show if user is accredited -->
                                            <!--<img src="/img/ui/icon-accredited.svg" class="accredited" alt="Accredited user">-->
                                            <p>
                                                <span class="u-bold">
                                                    <a :href="'/u/' + post.username">{{post.first_name}} {{post.surname}}</a>
                                                </span>
                                                <span class="u-normal">Posted to</span>
                                            </p>
                                        </div>
                                        <div>
                                            <p class="c-article__posted-ugc">
                                                <span>
                                                    <a :href="'/' + post.community_url">
                                                        <img :src="$simpleStore.cloudinaryUrl(25, 25, 'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)" :alt="post.community_name">
                                                    </a>
                                                </span>
                                                <span class="u-bold">
                                                    <a :href="'/' + post.community_url" id="article-community-name">{{post.community_name}}</a>
                                                </span>
                                                <span class="u-normal">{{post.birthday_long}}</span>
                                            </p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="c-article__postfrom">
                                            <div class="c-article__postfrom-inner">
                                                <div>
                                                    <p class="u-color-grey2 u-text-small u-bold u-normal@m">Post from</p>
                                                    <div v-if="typeof post.duplicates != 'undefined' && post.duplicates.length > 0"
                                                         v-for="dupe in post.duplicates"
                                                         @click="showNetworkPost(dupe.network_id, post.dyadey_id, dupe.post_id)"
                                                         :class="getNetworkClasses(dupe.network_id)"
                                                         v-html="getNetworkMarkup(dupe.network_id)">
                                                    </div>
                                                    <div v-else :class="['c-article__social', 'active c-article__social--' + post.network_name.toLowerCase()]">
                                                        <p><a :href="'/' + post.community_url + '/' + dupe.dyadey_id">{{post.network_name}}</a></p>
                                                    </div>
                                                </div>
                                                <p class="c-article__posted-non-ugc">
                                                    <span class="c-article__posted-details">
                                                        <a class="u-semibold u-bold@m" :href="'/' + post.community_url">
                                                            <img :src="$simpleStore.cloudinaryUrl(25, 25, 'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)" :alt="post.community_name">
                                                            <span id="article-community-name">{{post.community_name}}</span>
                                                        </a>
                                                    </span>
                                                    <time :datetime="postBirthdayDatetime" :title="postBirthdayDatetime">{{postBirthdayWords}}</time>
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </div>
<!--                                <aside class="c-article__menu" >&nbsp;</aside>-->
                                <aside :class="['c-card__menu-cta', { 'open': showContextMenu }]" @click.prevent="toggleContextMenu">&nbsp;</aside>
                                <div v-if="post.network_id === $simpleStore.Networks.DY" :class="['c-article__menu-items', { 'open': showContextMenu }]">
                                    <ul>
                                        <li><a href="#">Share</a></li>
                                        <li><a class="post-copy-link" href="#" :data-link="post.community_url + '/' + post.dyadey_id" @click.prevent="copyLink">Copy the URL <span v-show="$simpleStore.success">&#9989;</span></a></li>
                                        <!-- <li><a href="#0">Flag Content</a></li>
                                        <li><a href="#0">Hide User Posts</a></li>
                                        <li><a href="#0">Report User</a></li> -->
                                        <li v-if="$root.user !== false && post.user_id === $root.user.id"><a href="#" @click.prevent="modalDeletePost(post.post_id)">Delete Post</a></li>
                                        <li v-if="admin"><a href="#" @click.prevent="auditPost()">Audit Post <em>(admin only)</em></a></li>
                                        <li><a href="#" @click.prevent="toggleContextMenu">Cancel</a></li>
                                    </ul>
                                </div>
                                <div v-else :class="['c-article__menu-items', { 'open': showContextMenu }]">
                                    <ul>
                                        <!-- li><a href="#0">Share</a></li> -->
                                        <li><a class="post-copy-link" href="#" :data-link="post.community_url + '/' + post.dyadey_id" @click.prevent="copyLink">Copy the URL <span v-show="$simpleStore.success">&#9989;</span></a></li>
                                        <!-- <li><a href="#0">Flag Content</a></li> -->
                                        <li><a :href="post.network_id !== $simpleStore.Networks.IN ? post.uri : post.source" target="_blank">View Original Source</a></li>
                                        <li v-if="admin"><a href="#" @click.prevent="modalDeletePost(post.post_id)">Delete Post <em>(admin only)</em></a></li>
                                        <li><a href="#" @click.prevent="toggleContextMenu">Cancel</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="c-article__title--h1 u-order-1@m"><h1>{{postTitle}}</h1></div>
<!--                            <div class="c-article__posted c-article__posted&#45;&#45;reposted">
                                <div class="c-article__posted-by">
                                    <div>
                                        <img src="/img/user/article.png" alt="Article Posted by">
                                        <p><span>Harry Smith and 67 others</span> reposted to</p>
                                    </div>

                                    <div>
                                        <img src="/img/article-game-of-thrones.png" class="article-img"
                                             alt="Game of Thrones Article">
                                        <p>Game of Thrones</p>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </header>
                <router-view></router-view>

                <a v-if="$root.user !== false" :href="'/post/create/' + post.community_url" class="c-article__add"></a>
                <a v-else @click.prevent="showMemberPanel()" class="c-article__add"></a>
            </article>
            <related-content></related-content>
        </div>
        <modal></modal>
        <transition name="fade">
            <div v-if="showDeleteModal" class="c-cards__menu--delete">
                <div class="o-grid o-grid--center u-bg-white">
                    <div class="o-grid__item u-width-full u-a-center u-p-y6 u-p-x6">
                        <template v-if="showDeleteDraft === false">
                            <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">Delete Post</h4>
                            <p class="u-m-b3">Are you sure you want to delete this post?</p>
                        </template>
                        <template v-else>
                            <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">Delete Draft</h4>
                            <p class="u-m-b3">Are you sure you want to delete this post?</p>
                        </template>
                        <div class="u-flex u-flex-justify-center">
                            <button v-if="$root.user !== false && post.user_id === $root.user.id" class="c-btn c-btn--red u-m-r3" @click="deletePost()">Yes delete my {{ item }}</button>
                            <button v-else-if="admin === true" class="c-btn c-btn--red u-m-r3" @click="deleteCommunityPost()">Yes delete community post</button>
                            <button class="c-btn c-btn--red is-outline" @click="closeModal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="admin && showAuditPost" class="c-cards__menu--delete">
                <div class="o-grid o-grid--center u-bg-white">
                    <div class="o-grid__item u-width-full u-a-center u-p-y6 u-p-x6">
                        <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">Audit Post</h4>
                        <p class="u-m-b3">Classify post as appropriate below:</p>
                        <div class="u-flex u-flex-justify-center">
                            <button class="c-btn c-btn--red u-m-r3" @click="classifyPost('very good')">Very Good</button>
                            <button class="c-btn c-btn--red u-m-r3" @click="classifyPost('average')">Average</button>
                            <button class="c-btn c-btn--red u-m-r3" @click="classifyPost('bad')">Bad</button>
                            <button class="c-btn c-btn--red u-m-r3" @click="classifyPost('inappropriate')">Inappropriate</button>
                            <button class="c-btn c-btn--red is-outline" @click="closeModal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </main>
</template>

<script>
import Modal from "../Modal.vue";
import RelatedContent from "./RelatedContent";

export default {
    components: {
        Modal,
        RelatedContent
    },
    data() {
        return {
            activeNetwork: null,
            admin: false,
            post: this.$root.post,
            postBirthdayWords: this.$root.post.birthday_long,
            postBirthdayDatetime: this.$root.post.birthday_short,
            postTitle: this.$root.post.post_page_title,
            headHeight: 0,
            showAuditPost: false,
            showContextMenu: false,
            showDeleteModal: false,
            showDeleteDraft: false,
            sticky: false
        }
    },
    created() {
        this.$root.$on('update-post-data', (postBirthdayDatetime, postBirthdayWords, postTitle) => {
            this.postBirthdayDatetime = postBirthdayDatetime;
            this.postBirthdayWords = postBirthdayWords;
            this.postTitle = postTitle;
        });
        this.$root.$on('menu-toggle-post', (data) => {
            this.toggleContextMenu(true);
        });
    },
    mounted() {
        window.addEventListener('scroll', this.monitorScroll);
        this.headHeight = this.$refs.articleHead.clientHeight;
        // full width image
        if (this.post.network_id === this.$simpleStore.Networks.DY && this.post.thumbnail) {
            // remove images from the content so it is not displayed twice for UGC
            /*let figure = document.querySelector('#content figure.image');
            let fullWidth = false;
            // if class on image is only 'image' then must be full width
            if (figure != null && figure.classList.length === 1 && figure.classList[0] === 'image') {
                fullWidth = true;
            }
            this.post.content = this.post.content.replace(/<figure.+?class=".*?image.*?".*?>.+<\/figure>/, '');
            if (fullWidth === true) {
                let thumb = document.getElementById('thumbnail');
                thumb.classList.add('u-absolute-full-width');
                let fullWidthImage = document.querySelector('#thumbnail img');
                setTimeout(() => {
                    console.log('fullWidthImage.offsetHeight', fullWidthImage.offsetHeight);
                    let wrapperHeight = fullWidthImage.offsetHeight;
                    // wrap thumb in a static div
                    let parent = thumb.parentNode;
                    let wrapper = document.createElement('div');
                    wrapper.style.position = 'static';
                    wrapper.style.height = wrapperHeight + 'px';
                    parent.replaceChild(wrapper, thumb);
                    wrapper.appendChild(thumb);
                }, 100);
            }*/
        }
    },
    destroy() {
        window.removeEventListener('scroll', this.monitorScroll)
    },
    computed: {
        player() {
            return this.$refs.youtube.player
        }
    },
    methods: {
        monitorScroll() {
            if (typeof this.$refs.articleTitle == 'undefined') {
                return;
            }
            let mediaSize = this.$simpleStore.getMediaSize();
            // don't use sticky for s and xs breakpoints
            if (['xs', 's'].includes(this.$simpleStore.getMediaSize())) {
                return;
            }
            this.scrollPosition = window.scrollY;
            if (this.scrollPosition > (this.$parent.$refs.pageHead.clientHeight + this.$refs.communityLogo.clientHeight)) {
                this.sticky = true;
                this.$refs.articleHead.style.height = this.headHeight + 'px';
            } else {
                this.sticky = false;
                this.$refs.articleHead.style.height = 'auto';
            }
        },
        playing() {
            //console.log('\o/ we are watching!!!');
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
        toggleContextMenu(clickOutside = false) {
            this.admin = this.$root.$children[0].admin;
            this.showContextMenu = this.$simpleStore.contextMenu(this, clickOutside);
        },
        modalDeletePost(postId) {
            this.item = 'post';
            this.showDeleteDraft = false;
            this.showDeleteModal = true;
            // hide context menu without unfading background
            this.showContextMenu = false;
            this.$simpleStore.showContextMenu = false;
        },
        closeModal() {
            this.showDeleteModal = false;
            this.showContextMenu = false;
            this.$root.$emit('unfade-page');
        },
        deleteCommunityPost() {
            if (this.$root.$children[0].admin !== true) {
                return;
            }
            this.$http.post('/post/admindelete', { post_id: this.post.post_id }).then(response => {
                if (response.data.error === false) {
                    sessionStorage.removeItem('c' + this.post.community_id);
                    window.location = '/' + this.post.community_url;
                }
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        deletePost() {
            this.$http.post('/post/deletemine', { post_id: this.post.post_id }).then(response => {
                if (response.data.error === false) {
                    sessionStorage.removeItem('c' + this.post.community_id);
                    window.location = '/' + this.post.community_url;
                }
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        auditPost() {
            this.showAuditPost = true;
            this.showContextMenu = false;
        },
        classifyPost(classification) {
            this.admin = this.$root.$children[0].admin;
            this.$http.post('/post/audit', { post_id: this.post.post_id, classification: classification }).then(response => {
                if (response.data.error === false) {
                    sessionStorage.removeItem('c' + this.post.community_id);
                    window.location = '/' + this.post.community_url;
                }
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        showNetworkPost(networkId, dyadeyId, postId) {
            this.activeNetwork = networkId;
            this.$root.$emit('get-post', dyadeyId, postId);
        },
        getNetworkMarkup(networkId) {
            return '<p>\n' +
                '<a :href="#">' + this.$simpleStore.NetworkNames[networkId].charAt(0).toUpperCase() + this.$simpleStore.NetworkNames[networkId].substring(1) + '</a>\n' +
                '</p>';
        },
        getNetworkClasses(networkId) {
            let network = 'c-article__social--' + this.$simpleStore.NetworkNames[networkId];
            if (this.activeNetwork == null) {
                this.activeNetwork = this.$root.post.duplicates[0].network_id;
            }
            return ['c-article__social', network, networkId === this.activeNetwork ? 'active' : ''];
        }
    }
}
</script>
